import Model from './Model';

class Plan extends Model {
  getPlanName() {
    return this.attrs.planName;
  }

  getDescription() {
    return this.attrs.description;
  }

  getAmount() {
    return this.attrs.amount;
  }

  getCurrency() {
    return this.attrs.currency;
  }

  getDuration() {
    return this.attrs.duration;
  }

  getFeatures() {
    return this.attrs.features;
  }

  getPlanId() {
    return this.attrs.planId;
  }

  getApplyCount() {
    return this.attrs.applyCount;
  }

  setApplyCount(value) {
    this.attrs.applyCount = value;
    return this; 
  }
}

export default Plan;
